import { render, staticRenderFns } from "./ownRole.vue?vue&type=template&id=380bcd7c&scoped=true&"
import script from "./ownRole.vue?vue&type=script&lang=js&"
export * from "./ownRole.vue?vue&type=script&lang=js&"
import style0 from "./ownRole.vue?vue&type=style&index=0&id=380bcd7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380bcd7c",
  null
  
)

export default component.exports